import { api } from '../client';
import { unwrap } from '../unwrap';
import type { AuthResult, OtpSendResult } from '../types';

export const authApi = {
  async sendEmailCode(email: string): Promise<OtpSendResult> {
    const raw = await api.post<unknown>('/api/v1/auth/email/send', { email }, { auth: false });
    return unwrap<OtpSendResult>(raw);
  },

  async verifyEmailCode(email: string, code: string, nickname?: string): Promise<AuthResult> {
    const raw = await api.post<unknown>(
      '/api/v1/auth/email/verify',
      { email, code, nickname },
      { auth: false }
    );
    return unwrap<AuthResult>(raw);
  },

  async sendSmsCode(phone: string): Promise<OtpSendResult> {
    const raw = await api.post<unknown>('/api/v1/auth/sms/send', { phone }, { auth: false });
    return unwrap<OtpSendResult>(raw);
  },

  async verifySmsCode(phone: string, code: string, nickname?: string): Promise<AuthResult> {
    const raw = await api.post<unknown>(
      '/api/v1/auth/sms/verify',
      { phone, code, nickname },
      { auth: false }
    );
    return unwrap<AuthResult>(raw);
  },

  logout: () => api.post<{ success: true }>('/api/v1/auth/logout'),

  // ----- Bind / Unbind -----

  async sendBindEmailCode(email: string): Promise<unknown> {
    return api.post('/api/v1/auth/bind/email/send', { email });
  },

  async verifyBindEmail(email: string, code: string): Promise<unknown> {
    return api.post('/api/v1/auth/bind/email/verify', { email, code });
  },

  async sendBindPhoneCode(phone: string): Promise<unknown> {
    return api.post('/api/v1/auth/bind/phone/send', { phone });
  },

  async verifyBindPhone(phone: string, code: string): Promise<unknown> {
    return api.post('/api/v1/auth/bind/phone/verify', { phone, code });
  },

  async unbindEmail(): Promise<unknown> {
    return api.post('/api/v1/auth/unbind/email');
  },

  async unbindPhone(): Promise<unknown> {
    return api.post('/api/v1/auth/unbind/phone');
  },
};
